import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-competition-item',
  templateUrl: './competition-item.component.html',
  styleUrls: ['./competition-item.component.scss']
})
export class CompetitionItemComponent implements OnInit {
  @Input() title: string;
  showDetails: boolean;

  constructor() {
    this.showDetails = false;
  }

  ngOnInit() {
  }

  onToggle() {
    this.showDetails = !this.showDetails;
  }

}
